import React from "react";
import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import { Toaster } from "react-hot-toast";
import Evictions from "./pages/Evictions";
import Prevents from "./pages/Prevents";
import RiskMap from "./pages/RiskMap";
import FlashAlerts from "./pages/FlashAlerts/Index";
import PrivateRoutes from "./components/layouts/PrivateRoutes";
import BaseLayout from "./components/layouts/BaseLayout";
import Downloads from "./pages/Downloads";
import PowerBIReport from "./pages/PowerBIReport";
import Home from "./pages/Home";
import FlashAlertDetails from "./pages/FlashAlerts/FlashAlertDetails";
import AdminPanel from "./pages/AdminPanel"; // Admin Panel Component
import { trackVisit } from "./utils/visitors";

const App: React.FC = () => {

  useEffect(() => {
    trackVisit();
  }, []);

  return (
    <>
      <Routes>
        {/* Public route for login */}
        <Route path="/login" element={<LoginPage />} />

        {/* All other routes share BaseLayout */}
        <Route path="/" element={<BaseLayout />}>
          {/* Public routes */}
          <Route index element={<Home />} />
          <Route path="/evictions" element={<Evictions />} />
          <Route path="/preventions" element={<Prevents />} />
          <Route path="/riskmap" element={<RiskMap />} />
          <Route path="/flash-alerts" element={<FlashAlerts />} />
          <Route path="/flash-alerts/:id" element={<FlashAlertDetails />} />
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/analytics" element={<PowerBIReport />} />

          {/* Private route wrapped inside PrivateRoutes */}
          <Route element={<PrivateRoutes />}>
            <Route path="/admin-panel" element={<AdminPanel />} />
          </Route>
        </Route>
      </Routes>

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 10000,
        }}
      />
    </>
  );
};

export default App;
